import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPortfolioBankProductEditRequestDTO,
	type PortfolioDetailResponseDTO,
	patchPortfolioBankProductsIdV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePatchPortfolioBankProductMutation = (id: number) => {
	const queryClient = useQueryClient();

	return useMutation<
		PortfolioDetailResponseDTO,
		Error,
		Partial<ClientPortfolioBankProductEditRequestDTO>
	>({
		mutationFn: processResponse((requestContract) =>
			patchPortfolioBankProductsIdV2(requestContract, id),
		),
		onSuccess: (data) => {
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioLists(),
			});
			queryClient.setQueryData(PortfolioKeys.portfolioDetail(id), data);
		},
	});
};
